import './style/index.js';

import _Statistic from './Statistic';

export type { StatisticProps, StatisticRef } from './Statistic';
export * from './type';

export const Statistic = _Statistic;
export default Statistic;
